import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoRequestsGetRes } from "./abst/DtoRequestsGetRes";

export class DtoRequestsGetResImple extends DtoRequestsGetRes {
  public pager = new DtoApiPager();
}
